export const SUPPORT_EMAIL = "info@interactggz.nl";

export type PortalAuthErrorCode =
  | "session_missing"
  | "session_recover_failed"
  | "session_expired"
  | "token_invalid"
  | "origin_forbidden"
  | "network"
  | "portal_error"
  | "unknown";

export function getPortalAuthErrorCode(err: unknown): PortalAuthErrorCode {
  if (err && typeof err === "object" && "code" in err) {
    const code = String((err as { code: string }).code);
    if (isPortalAuthErrorCode(code)) return code;
  }
  return "unknown";
}

function isPortalAuthErrorCode(code: string): code is PortalAuthErrorCode {
  return (
    code === "session_missing" ||
    code === "session_recover_failed" ||
    code === "session_expired" ||
    code === "token_invalid" ||
    code === "origin_forbidden" ||
    code === "network" ||
    code === "portal_error" ||
    code === "unknown"
  );
}

export function messageForPortalAuthError(code: PortalAuthErrorCode): string {
  switch (code) {
    case "session_missing":
      return "Geen tool-sessie. Open deze tool via het portal (Tools → Open tool), niet via een bladwijzer of directe URL.";
    case "session_recover_failed":
      return `De sessie kon niet worden hersteld. Waarschijnlijk blokkeert je browser cookies of strikte privacy-instellingen het plaatsen ervan. Excuses voor het ongemak. Blijft het probleem? Mail naar ${SUPPORT_EMAIL}.`;
    case "session_expired":
      return "Je tool-sessie is verlopen (24 uur). Open de tool opnieuw via het portal.";
    case "token_invalid":
      return "De startlink is verlopen of al gebruikt. Ga terug naar het portal en open de tool opnieuw.";
    case "origin_forbidden":
      return "Deze tool-URL is niet gekoppeld aan het portal. Gebruik hetzelfde adres als in het portal (bijv. localhost, niet 127.0.0.1).";
    case "network":
      return "Kan het portal niet bereiken. Controleer je internetverbinding en of het portal draait.";
    case "portal_error":
      return "Het portal gaf een onverwachte fout. Probeer het later opnieuw of open de tool via het portal.";
    default:
      return "Inloggen mislukt. Open deze tool via het portal (Tools → Open tool).";
  }
}
